import { Injectable, EventEmitter, Injector } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ModalState, ActionWindowModel } from '../model/action-window-model';

@Injectable()
export class ActionWindowService {
  constructor() {}

  private _currentState: EventEmitter<any> = new EventEmitter<any>();
  private _actionResult: Subject<any>;

  currentState = this._currentState.asObservable();

  close(): void {
    this._actionResult?.complete();
    this._currentState.emit({ state: ModalState.CLOSE });
  }

  complete(actionResult: any) {
    this._actionResult?.next(actionResult);
    this.close();
  }

  destroy(): void {
    this._actionResult?.complete();
    this._currentState.emit({ state: ModalState.DESTROY });
  }

  open(component: any, injector: Injector, providers?: any, dataContext?: any, wide?: boolean): Observable<any> {
    this._actionResult?.complete();
    this._actionResult = new Subject<any>();

    this._currentState.emit(new ActionWindowModel(component, dataContext, injector, providers, wide));
    return this._actionResult.asObservable();
  }
}
